<div class="formula-form">
  <div class="form-body">
    <div class="field-row">
      <div class="field">
        <label>Name</label>
        <input type="text" [(ngModel)]="model.name" placeholder="e.g. Solo 401k eligibility"/>
      </div>
      <div class="field field-narrow">
        <label>Formula Type</label>
        <select [(ngModel)]="model.formulaType" (ngModelChange)="onFormulaTypeChange()">
          <option value="BOOLEAN">Trigger Formula</option>
          <option value="NUMERIC">Plan Amount</option>
          <option value="STRING">Why Description</option>
        </select>
      </div>
      <div class="field field-checkbox">
        <label>&nbsp;</label>
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="model.active"/> Active
        </label>
      </div>
    </div>

    <div class="field">
      <label>Description</label>
      <textarea rows="2" [(ngModel)]="model.description" placeholder="Optional notes about what this test case covers"></textarea>
    </div>

    <div class="field">
      <label>Formula Source</label>
      <div class="toggle-row">
        <button type="button" [class.active]="!useRuleReference" (click)="toggleSource(false)">Custom formula</button>
        <button type="button" [class.active]="useRuleReference" (click)="toggleSource(true)">Reference existing rule</button>
      </div>
    </div>

    <div class="field" *ngIf="!useRuleReference">
      <label>Formula</label>
      <textarea rows="3" [(ngModel)]="model.formula" placeholder="e.g. n(agi) > 200000 &amp;&amp; b(has_business)"></textarea>
    </div>

    <div class="field" *ngIf="useRuleReference">
      <label>Rule</label>
      <select [(ngModel)]="selectedRule" (ngModelChange)="onRuleSelected()">
        <option [ngValue]="null">Select a rule...</option>
        <option *ngFor="let rule of availableRules" [ngValue]="rule">{{rule.name}}</option>
      </select>
      <div class="rule-preview" *ngIf="selectedRule">
        <div class="rule-preview-label">Rule formula ({{formulaTypeLabel(model.formulaType)}}) — editable:</div>
        <textarea rows="3" class="rule-formula-edit" [(ngModel)]="ruleFormulaText"></textarea>
        <div class="rule-edit-warning" *ngIf="ruleFormulaDirty()">
          Saving will update this rule's formula in the database — it changes live plan
          calculations and every test case referencing this rule.
        </div>
      </div>
    </div>

    <div class="field-row">
      <div class="field">
        <label class="field-label-row">
          <span>Input Values (JSON)</span>
          <button type="button" class="detect-btn" (click)="detectVariables()">Detect Variables</button>
        </label>
        <textarea rows="3" [(ngModel)]="inputValuesText" (blur)="validateJson()" placeholder='{"agi": 250000, "has_business": true}'></textarea>
        <div class="field-error" *ngIf="jsonError">{{jsonError}}</div>
      </div>
      <div class="field field-narrow">
        <label>Expected Result</label>
        <select *ngIf="model.formulaType === 'BOOLEAN'" [(ngModel)]="model.expectedResult">
          <option value="true">true</option>
          <option value="false">false</option>
        </select>
        <input *ngIf="model.formulaType === 'NUMERIC'" type="number" [(ngModel)]="model.expectedResult"/>
        <input *ngIf="model.formulaType === 'STRING'" type="text" [(ngModel)]="model.expectedResult"/>
      </div>
    </div>

    <div class="result-panel" *ngIf="testResult">
      <div class="result-header" [ngClass]="{
        'result-error': testResult.errorMessage,
        'result-pass': !testResult.errorMessage && model.expectedResult && testResult.passed,
        'result-fail': !testResult.errorMessage && model.expectedResult && !testResult.passed,
        'result-neutral': !testResult.errorMessage && !model.expectedResult
      }">
        <ng-container *ngIf="testResult.errorMessage">Error</ng-container>
        <ng-container *ngIf="!testResult.errorMessage && model.expectedResult">{{testResult.passed ? 'PASS' : 'FAIL'}}</ng-container>
        <ng-container *ngIf="!testResult.errorMessage && !model.expectedResult">Result</ng-container>
      </div>
      <pre *ngIf="!testResult.errorMessage">Actual: {{testResult.actualResult}}<ng-container *ngIf="model.expectedResult">
Expected: {{model.expectedResult}}</ng-container></pre>
      <pre class="error-text" *ngIf="testResult.errorMessage">{{testResult.errorMessage}}</pre>
    </div>
  </div>

  <div class="form-actions">
    <button type="button" class="btn-secondary" [disabled]="testing" (click)="test()">Test</button>
    <span class="spacer"></span>
    <button type="button" class="btn-secondary" (click)="cancel()">Cancel</button>
    <button type="button" class="btn-primary" [disabled]="saving" (click)="save()">Save</button>
  </div>
</div>
